const state = {
  alert: null,
  appLoading: false,
};

export default state;
